import Button from '@berlitz/button'
import { H2 } from '@berlitz/globals'
import Modal from '@berlitzplatforms/micro.ui.modal'
import Spacer from '@berlitz/spacer'
import MultiSelect from '@berlitzplatforms/micro.ui.multi-select-legacy'
import Select from '@components/Select'
import { ISearchInstructorFilters } from '@interfaces/ISearchInstructorFilters'
import React, { useState, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { FILTERS } from '../filters'
import { FieldLabel, Filter } from '../style'
import { ButtonWrapper, ModalFilterWrapper } from './style'

interface FilterModalProps {
  open: boolean
  onClose: () => void
  updateFilters: (_f: ISearchInstructorFilters) => void
  programLang?: string
  filters?: ISearchInstructorFilters
}

const FilterModal: React.FC<FilterModalProps> = ({
  open,
  onClose,
  programLang = 'English',
  updateFilters,
  filters = {},
}) => {
  const intl = useIntl()
  const [temp, setTemp] = useState<ISearchInstructorFilters>({ ...filters })

  const updateTemp = (type: string, value: string[] | string | undefined) => {
    const newFilter = { ...temp }
    newFilter[type] = value
    setTemp(newFilter)
  }

  const handleUpdate = () => {
    updateFilters(temp)
    onClose()
  }

  useEffect(() => {
    setTemp(filters)
  }, [filters])

  return (
    <Modal open={open} onClose={onClose}>
      <H2>
        <FormattedMessage id="Modify filters" defaultMessage="Modify filters" />
      </H2>
      <Spacer size="lg" />
      <ModalFilterWrapper>
        <Filter>
          <Select
            label={intl.formatMessage({ id: 'Speaks', defaultMessage: 'Speaks' })}
            options={[{ label: programLang }]}
            value={programLang}
            onChange={() => {}}
            disabled
          />
        </Filter>
        <Filter>
          <FieldLabel>
            <FormattedMessage id="Also speaks" defaultMessage="Also speaks" />
          </FieldLabel>
          <MultiSelect
            options={FILTERS.LANGUAGES}
            onChange={(value) => updateTemp('speaks', value)}
            preSelect={filters?.speaks}
          />
        </Filter>
        <Filter>
          <FieldLabel>
            <FormattedMessage id="Specialisation" defaultMessage="Specialisation" />
          </FieldLabel>
          <MultiSelect
            options={FILTERS.SPECIALIZATIONS}
            onChange={(value) => updateTemp('specialisation', value)}
            preSelect={filters?.specialisation}
          />
        </Filter>
      </ModalFilterWrapper>
      <Spacer size="lg" />
      <ButtonWrapper>
        <Button onClick={onClose}>{intl.formatMessage({ id: 'Cancel', defaultMessage: 'Cancel' })}</Button>
        <Button onClick={handleUpdate}>{intl.formatMessage({ id: 'Update', defaultMessage: 'Update' })}</Button>
      </ButtonWrapper>
    </Modal>
  )
}

export default React.memo(FilterModal)
